import {Component, Input, OnInit} from '@angular/core';
import {StellenService} from '../stellen.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-stellenbeschreibung',
    templateUrl: './stellenbeschreibung.component.html',
    styleUrls: ['./stellenbeschreibung.component.css']
})
export class StellenbeschreibungComponent implements OnInit {

    @Input() stellenangebote: any;

    stelle: object;
    stellenId: String = '';

    constructor(private stellenService: StellenService,
                private route: ActivatedRoute,
                private router: Router) {
    }

    ngOnInit() {
        window.scroll(0, 0);
        this.stellenId = this.route.snapshot.params.id;
        this.getStelle();
    }

    getStelle() {
        this.stellenService.getStellenangebote(false, '').then((response) => {
            for (const stelle of response) {
                if (stelle.id === this.stellenId) {
                    this.stelle = stelle;
                    if (!stelle.hr.hasOwnProperty('name')) {
                        this.stellenService.getAnsprechpartner(stelle.data.zustaendige[0]).then(function (res) {
                            stelle.hr = res;
                        });
                    }
                }
            }
        });
    }

    goBack() {
        this.router.navigate(['/stellen']);
    }
}
